import { RootState } from 'store';

const StatesLookupState = (state: RootState) => state.lookups.states;
export const selectStates = (state: RootState) => StatesLookupState(state).rows;
